var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LinesChart"},[_c('linesChart',{attrs:{"type":"line","height":_vm.height,"width":_vm.width,"options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }